export const FEATURE_FLAGS = {
  insights: {
    name: "Insights",
    description:
      "This is like a slack channel where people get updates on what is happening and can comment on it.",
    defaultValue: false
  },
  productPageDescriptionAnalysis: {
    name: "Extended Product Page Description Analysis",
    description:
      "Enables AI-powered analysis of product descriptions to enhance content quality and effectiveness.",
    defaultValue: false
  }
} as const;

export type FeatureFlagKey = keyof typeof FEATURE_FLAGS;

export type FlagHasVariants<K extends FeatureFlagKey> = (typeof FEATURE_FLAGS)[K] extends {
  variants: readonly string[];
}
  ? true
  : false;

export type FlagVariants<K extends FeatureFlagKey> = (typeof FEATURE_FLAGS)[K] extends {
  variants: readonly (infer V)[];
}
  ? V
  : never;

export type FeatureFlagValue<K extends FeatureFlagKey> =
  FlagHasVariants<K> extends true ? false | FlagVariants<K> : boolean;

export type FeatureFlagValues = {
  [K in FeatureFlagKey]: FeatureFlagValue<K>;
};

export const hasVariants = (key: FeatureFlagKey): boolean => {
  const flag = FEATURE_FLAGS[key];

  return "variants" in flag && Array.isArray(flag.variants) && flag.variants.length > 0;
};

export const getVariants = (key: FeatureFlagKey): readonly string[] => {
  const flag = FEATURE_FLAGS[key];

  if ("variants" in flag && Array.isArray(flag.variants)) {
    return flag.variants;
  }

  return [];
};
